/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatIconRegistry } from "@angular/material/icon";
import { MatMenuTrigger } from "@angular/material/menu";
import { DomSanitizer } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { WhiteshopLoginComponent } from "src/app/features/auth-feature/whiteshop-login/whiteshop-login.component";
import { StoresService } from "src/app/services/catalog/stores.service";
import { DialogService } from "src/app/services/dialog-service/dialog.service";
import { ImagesService } from "src/app/services/images/images.service";
import { BusinessUnitsApiService } from "src/app/services/my-company/business-units/business-units-api.service";
import { LocalStorageService } from "src/app/services/shared/local-storage/local-storage.service";
import { SlotService } from "src/app/services/slot/slot.service";
import { UserService } from "valuchaincommon/common-services/user/user.service";
import { icons, currency } from "../../../environments/config";
import { UpdateAppointmentProductsService } from "src/app/services/inventory/update-appointment-products-service";
import { NotificationsComponent } from "./../../features/notifications/notifications/notifications.component";
declare const changebrowserlang: any;
import {
  isHappyBabyFlag,
  isJDXHomePage,
  isSRSMFlag,
  storeText,
  currency_symbols,
} from "../../../environments/config";
import { ProfileComponent } from "src/app/features/user/profile/profile.component";
import { ChangePasswordComponent } from "./../../features/auth-feature/change-password/change-password.component";
import { LocationService } from "src/app/services/location-service/location.service";
import { SubSink } from "subsink";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  public whiteShopLogo;
  public srsmLogo;
  public jdxLogo;
  public highlineLogo;
  public jdxDarkLogo = icons.jdxIcon.jdxDarkTotalLogo;
  public whiteshopDarkLogo = icons.whiteShopIcon.darkLogo;
  public defaultImage = icons.businessUserIcon.defaultImg;
  public blueCart = icons.liveshopIcon.blueCart;
  public isStoresSelected = false;
  public isBookingsSelected = false;
  public isOrdersSelected = false;
  public user: any;
  public userGroup;
  public isAppointment = true;
  public isCheckoutEnabled = false;
  public isCatalog = true;
  public companyLiveUrl;
  translateIconUrl = "assets/translate/icon.svg";
  translateBlackIconUrl = "assets/translate/blackIcon.svg";
  isSupplier = false;
  public isJDXHomePage = isJDXHomePage;
  showWishList = false;
  notifications = [];
  public languageList = [
    { code: "en", label: "English" },
    { code: "hi", label: "हिंदी" },
    { code: "ml", label: "മലയാളം" },
    { code: "ur", label: "اردو" },
    { code: "ta", label: "தமிழ்" },
    { code: "te", label: "తెలుగు" },
    { code: "mr", label: "मराठी" },
    { code: "pa", label: "ਪੰਜਾਬੀ" },
    { code: "kn", label: "ಕನ್ನಡ" },
    { code: "gu", label: "ગુજરાતી" },
  ];
  subscriptions: Subscription[] = [];
  @ViewChild("trigger") trigger: MatMenuTrigger;
  @ViewChild("language") language: MatMenuTrigger;
  @ViewChild("notificationsTrigger") notificationsTrigger: MatMenuTrigger;
  public storeText = storeText.text;
  subsink = new SubSink();
  constructor(
    public dialogService: DialogService,
    public imagesService: ImagesService,
    public router: Router,
    public localStorageService: LocalStorageService,
    public locationService: LocationService,
    public storesService: StoresService,
    public dialog: MatDialog,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private slotService: SlotService,
    public businessUnitService: BusinessUnitsApiService,
    public updateAppointmentProductsService: UpdateAppointmentProductsService,
    public valuChainUserService: UserService,
    public cdRef: ChangeDetectorRef
  ) {}

  ngAfterViewInit() {
    window.addEventListener(
      "storage",
      () => {
        if (
          !localStorage.getItem("user") &&
          this.router.url !== "/" &&
          !window.location.href.includes("promotionBooking") &&
          !window.location.href.includes("3Dmodel") &&
          !(
            (window.location.href.includes("scheduledAppointment") &&
              window.location.href.includes("isPromotions")) ||
            window.location.href.includes("liveshop")
          )
        ) {
          this.dialog.closeAll();
          this.router.navigateByUrl("/");
          this.localStorageService.getConfig();
          let config = JSON.parse(localStorage.getItem("companyConfig"));
          if (config && config.whiteshop) {
            this.isCatalog = config.whiteshop.catalogueAccessToSalesperson;
            this.isAppointment =
              config.whiteshop.isScheduledAppointmentsEnabled;
            this.isCheckoutEnabled = config.whiteshop.isCheckoutProcessEnabled;
          }
        }
      },
      false
    );
  }

  ngOnInit(): void {
    this.subsink.add(
      this.slotService.detachChangeListeners.subscribe((detach) => {
        if (!detach) this.cdRef.reattach();
        else this.cdRef.detach();
      })
    );
    this.user = JSON.parse(localStorage.getItem("user"));
    if (isSRSMFlag.flag && localStorage.getItem("user")) {
      if (
        localStorage.getItem("isSupplier") &&
        JSON.parse(localStorage.getItem("isSupplier"))
      ) {
        this.isSupplier = true;
      } else {
        this.isSupplier = false;
      }
    }
    let config = JSON.parse(localStorage.getItem("companyConfig"));
    if (config && config.whiteshop) {
      this.isCatalog = config.whiteshop.catalogueAccessToSalesperson;
      this.isAppointment = config.whiteshop.isScheduledAppointmentsEnabled;
      this.isCheckoutEnabled = config.whiteshop.isCheckoutProcessEnabled;
    }
    this.userGroup = JSON.parse(localStorage.getItem("userGroup"));
    console.log(this.userGroup);
    this.slotService.throwLoginCheckFlag.subscribe((res) => {
      if (res && localStorage.getItem("userGroup")) {
        this.userGroup = JSON.parse(localStorage.getItem("userGroup"));
        console.log(this.userGroup);
      }
    });
    this.subscriptions.push(
      this.localStorageService.islocalStorageChannelsUpdated.subscribe(
        (isUpdated) => {
          if (isUpdated) {
            this.setLogo();
            let config = JSON.parse(localStorage.getItem("companyConfig"));
            if (config && config.whiteshop) {
              this.isCatalog = config.whiteshop.catalogueAccessToSalesperson;
              this.isAppointment =
                config.whiteshop.isScheduledAppointmentsEnabled;
              this.isCheckoutEnabled =
                config.whiteshop.isCheckoutProcessEnabled;
            }
          }
        }
      )
    );
    this.setLogo();
    this.loggedIn();
    this.iconRegistry.addSvgIcon(
      "translate",
      this.sanitizer.bypassSecurityTrustResourceUrl(this.translateIconUrl)
    );
    this.iconRegistry.addSvgIcon(
      "customerCartIcon",
      this.sanitizer.bypassSecurityTrustResourceUrl(
        "assets/icons/cart-white.svg"
      )
    );
    this.iconRegistry.addSvgIcon(
      "translateBlack",
      this.sanitizer.bypassSecurityTrustResourceUrl(this.translateBlackIconUrl)
    );
    this.iconRegistry.addSvgIcon(
      "consumerCart",
      this.sanitizer.bypassSecurityTrustResourceUrl(
        "assets/icons/consumer-cart.svg"
      )
    );
    if (localStorage.getItem("user")) {
      this.updateAppointmentProductsService
        .getCartData(false, true)
        .subscribe((res) => {
          this.slotService.cartCount = res[0]?.cartCount
            ? res[0]?.cartCount
            : 0;
        });
    }
    this.localStorageService.islocalStorageUpdated.subscribe((user) => {
      if (user) {
        this.user = JSON.parse(localStorage.getItem("user"));
        // this.isUserConsumer = this.user.companies.findIndex(company => company.consumer) >=0 ? true: false;
      }
    });
    const id = this.slotService.currentBusinessUnit?._id;
    if (id && !window.location.href.includes("liveshop")) {
      // this.businessUnitService // has to be replaced with a better way, probably using the business-unit-detail ngOnInIt
      //   .getBusinessUnitDetails(id)
      //   .subscribe((businessUnit) => {
      this.valuChainUserService.selectedBusinessUnitData = this.slotService.currentBusinessUnit;
      this.valuChainUserService.currentBusinessUnitDetailBS.next(
        this.slotService.currentBusinessUnit
      );
      if (!localStorage.getItem("companyConfig")) {
        this.localStorageService.getCompanyConfig().subscribe((res) => {
          // try to get the data from liveshop videoCall and use it, check if it work for both customer/salesman
          if (res.whiteshop?.currency?.length) {
            currency.currency = currency_symbols[res.whiteshop.currency];
          }
          localStorage.setItem("companyConfig", JSON.stringify(res));
        });
      }
      // });
    }
    config = JSON.parse(
      localStorage.getItem("companyConfig")
        ? localStorage.getItem("companyConfig")
        : localStorage.getItem("config")
    );
    this.showWishList =
      config?.whiteshop.enableWishlist &&
      localStorage.getItem("user") &&
      JSON.parse(localStorage.getItem("user")) &&
      JSON.parse(localStorage.getItem("user")).type &&
      JSON.parse(localStorage.getItem("user")).type === "B2C";
    if (!this.isUserConsumer() && !window.location.href.includes("liveshop")) {
      if (
        !this.storesService.notificationCount &&
        localStorage.getItem("user")
      ) {
        this.slotService.getNotifications(null, null, true).subscribe(
          (res) => {
            if (res) {
              this.storesService.notificationCount = res;
              this.localStorageService.isLoaderDisabled = false;
            }
          },
          (err) => {
            console.log(err);
            this.profileImageClicked();
            this.localStorageService.isLoaderDisabled = true;
          }
        );
      }
    }
  }
  ngOnDestroy() {
    this.subsink.unsubscribe();
  }
  setLogo() {
    let config = JSON.parse(
      localStorage.getItem("config")
        ? localStorage.getItem("config")
        : localStorage.getItem("companyConfig")
    );
    if (config) {
      if (config.whiteshop.companyLogo && config.whiteshop.companyLogo.length) {
        this.whiteShopLogo = config.whiteshop.companyLogo;
      } else if (isSRSMFlag.flag) {
        this.whiteShopLogo = icons.srsmIcon.srsmIcon;
      } else if (isJDXHomePage.flag && !isJDXHomePage.isHighLine) {
        this.whiteShopLogo = icons.jdxIcon.jdxLogo;
      } else if (isJDXHomePage.isHighLine) {
        this.whiteShopLogo = icons.highlineIcon.logo;
      } else if (isHappyBabyFlag.flag) {
        this.whiteShopLogo = icons.happybabyIcon.happybabyIcon;
      } else {
        this.whiteShopLogo = icons.whiteShopIcon.icon;
      }
    } else {
      if (isSRSMFlag.flag) {
        this.whiteShopLogo = icons.srsmIcon.srsmIcon;
      } else if (isJDXHomePage.flag && !isJDXHomePage.isHighLine) {
        this.whiteShopLogo = icons.jdxIcon.jdxLogo;
      } else if (isJDXHomePage.isHighLine) {
        this.whiteShopLogo = icons.highlineIcon.logo;
      } else if (isHappyBabyFlag.flag) {
        this.whiteShopLogo = icons.happybabyIcon.happybabyIcon;
      } else {
        this.whiteShopLogo = icons.whiteShopIcon.icon;
      }
    }
    this.localStorageService.isLogoUpdated.next([this.whiteShopLogo]);
  }
  showIcon() {
    const logedin = this.loggedIn();
    if (logedin) {
      return JSON.parse(localStorage.getItem("isLanguageTranslation"));
    } else {
      return false;
    }
  }
  // ngOnChanges(){
  //   this.showIcon()
  // }

  goToHome() {
    if (!this.isUserConsumer()) {
      this.isBookingsSelected = false;
      this.isStoresSelected = false;
      this.isOrdersSelected = false;
      if (localStorage.getItem("retailerToken")) {
        this.router.navigateByUrl("/homePage");
      } else if (localStorage.getItem("nVipaniwhiteshopkey")) {
        this.router.navigateByUrl("/user-homePage");
      } else {
        this.router.navigateByUrl("");
      }
      this.localStorageService.resetCallData();
      this.locationService.resetDates();
    }
  }
  goToCart() {
    this.router.navigateByUrl("/myorders/consumer-cart");
  }
  goToMyWishList() {
    if (
      localStorage.getItem("nVipaniwhiteshopkey") ||
      localStorage.getItem("retailerToken")
    ) {
      this.router.navigateByUrl("/mywishlist");
    } else {
      this.profileImageClicked();
    }
  }
  goToTemplates() {
    this.router.navigateByUrl("media-templates");
  }
  goToMyCompany() {
    if (localStorage.getItem("retailerToken")) {
      this.router.navigateByUrl("my-company");
      this.localStorageService.resetCallData();
      this.locationService.resetDates();
    }
  }
  goToMyBusinessUnits() {
    if (localStorage.getItem("retailerToken")) {
      this.router.navigateByUrl("my-company/my-units");
    }
    this.resetConsumerTabFilters();
    this.localStorageService.resetCallData();
    this.locationService.resetDates();
  }

  profileImageClicked() {
    if (this.router.url === "/" || this.router.url === "/learnmore") {
      const myDialogRef = this.dialogService.openMatDialog(
        WhiteshopLoginComponent,
        null,
        true,
        null,
        null,
        true,
        true
      );
      myDialogRef.afterClosed().subscribe((data) => {
        this.userGroup = JSON.parse(localStorage.getItem("userGroup"));
        console.log(this.userGroup);
      });
    } else if (this.router.url === "/stores") {
      const dialogRef = this.dialogService.openMatDialog(
        WhiteshopLoginComponent,
        true,
        true,
        null,
        null,
        true,
        true
      );
      dialogRef.afterClosed().subscribe((res) => {
        this.storesService.throwLoginFlag.next(true);
        this.userGroup = JSON.parse(localStorage.getItem("userGroup"));
        console.log(this.userGroup);
      });
    } else {
      this.router.navigateByUrl("my-company");
    }
  }

  goToMyAppointments() {
    // this.isBookingsSelected = true;
    // this.isStoresSelected = false;
    // this.isOrdersSelected = false;
    this.slotService.isDeletedAppointments = false;
    if (
      localStorage.getItem("retailerToken") ||
      (localStorage.getItem("nVipaniwhiteshopkey") &&
        localStorage.getItem("nVipaniwhiteshopUser"))
    ) {
      this.slotService.isCustomerBooking = false;
      this.router.navigateByUrl("/appointments");
    } else {
      this.profileImageClicked();
    }
    this.resetConsumerTabFilters();
    this.localStorageService.resetCallData();
    this.locationService.resetDates();
  }

  currentRouteLanding() {
    return (
      this.router.url === "/homePage" || this.router.url === "/user-homePage"
    );
  }

  getStoresText() {
    return localStorage.getItem("retailerToken")
      ? "My " + this.storeText
      : "All " + this.storeText + "s";
  }
  goToMyStore() {
    // this.isStoresSelected = true;
    // this.isBookingsSelected = false;
    // this.isOrdersSelected = false;
    // if (localStorage.getItem("nVipaniwhiteshopkey")) {
    if (
      localStorage.getItem("retailerToken") ||
      (localStorage.getItem("nVipaniwhiteshopkey") &&
        localStorage.getItem("nVipaniwhiteshopUser"))
    ) {
      if (isJDXHomePage.flag) {
        this.storesService.resetData();
      }
      this.router.navigateByUrl("stores");
    } else {
      this.profileImageClicked();
    }
    this.storesService.isReloaded.next(true);
    this.resetConsumerTabFilters();
    this.localStorageService.resetCallData();
    this.locationService.resetDates();
    // } else {
    //   return false;
    // }
  }

  openGuides() {
    this.router.navigateByUrl("guides");
  }
  getBookingText() {
    return localStorage.getItem("retailerToken")
      ? "My Appointments"
      : "My Bookings";
  }

  isRetailer() {
    return localStorage.getItem("retailerToken");
  }

  loggedIn() {
    return JSON.parse(localStorage.getItem("user")) && this.router.url !== "/";
  }

  logOut() {
    let customerUrl = "";
    if (
      this.isUserConsumer() &&
      !(
        this.userGroup &&
        (this.userGroup.name === "Admin" ||
          this.userGroup.name === "Manager" ||
          this.userGroup.name === "Supervisor")
      )
    ) {
      customerUrl = this.getCompanyLiveUrl();
    }
    let companyConfig;
    let currentBusinessUnit;
    let c2cKey;
    if (this.isUserConsumer() && localStorage.getItem("c2cKey")) {
      currentBusinessUnit = sessionStorage.getItem("currentBusinessUnit");
      companyConfig = localStorage.getItem("companyConfig");
      c2cKey = localStorage.getItem("c2cKey");
    }
    this.localStorageService.resetUserData();
    if (c2cKey) {
      localStorage.setItem("c2cKey", c2cKey);
      if (currentBusinessUnit) {
        sessionStorage.setItem("currentBusinessUnit", currentBusinessUnit);
      }
      if (companyConfig) {
        localStorage.setItem("companyConfig", companyConfig);
        localStorage.setItem("config", companyConfig);
        if (JSON.parse(companyConfig)?.owner?.company) {
          localStorage.setItem(
            "currentCompanyId",
            JSON.parse(companyConfig).owner.company
          );
        }
      }
    }
    this.localStorageService.resetCallData();
    this.localStorageService.divisionCallCount = 0;
    this.storesService.productsData = [];
    this.resetConsumerTabFilters();
    this.storesService.autoScroll = null;
    this.storesService.notificationCount = 0;
    this.storesService.notifications = null;
    this.localStorageService.islocalStorageChannelsUpdated.next(false);
    this.localStorageService.isRetailerVersion = false;
    this.router.navigateByUrl("/");
    this.localStorageService.getConfig();
    if (customerUrl) {
      window.location.assign(customerUrl);
    }
    // if (isSRSMFlag.flag && localStorage.getItem("user")) {
    //   console.log(JSON.parse(localStorage.getItem("company")));
    //   if (
    //     localStorage.getItem("company") &&
    //     JSON.parse(localStorage.getItem("company"))["localCode"].isSummary
    //   ) {
    //     this.isSupplier = false;
    //   } else {
    //     this.isSupplier = true;
    //   }
    // }
    // let code;
    // if (window.location.hostname.includes("kilburn")) {
    //   code = "KILBURN";
    // }
    // // if (code && code.length) {
    // this.localStorageService.getCompanyConfig(code).subscribe(
    //   (res) => {
    //     if (res) {
    //       localStorage.setItem("config", JSON.stringify(res));
    //       localStorage.setItem(
    //         "isLanguageTranslation",
    //         res["whiteshop"].isLanguageTranslation
    //       );
    //     }
    //     this.localStorageService.islocalStorageChannelsUpdated.next(true);
    //   },
    //   (err) => {
    //     this.localStorageService.islocalStorageChannelsUpdated.next(true);
    //   }
    // );
    // // }
  }
  changeLang(lang: string) {
    console.log(lang);
    changebrowserlang(lang);
  }

  // goToHome() {
  //   if (!localStorage.getItem('nVipaniwhiteshopkey')) {
  //     this.isBookingsSelected = false;
  //     this.isStoresSelected = true;
  //     this.isOrdersSelected = false;
  //     if (localStorage.getItem('retailerToken')) {
  //       this.router.navigateByUrl('my-company');
  //     } else {
  //       this.profileImageClicked();
  //     }
  //   }
  // }
  logoTypeWhite() {
    return (
      this.router.url === "/homePage" || this.router.url === "/user-homePage"
    );
  }
  setHighlight(path?) {
    if (path) {
      switch (path) {
        case "/stores": {
          this.isStoresSelected = true;
          this.isBookingsSelected = false;
          this.isOrdersSelected = false;
          break;
        }
        case "/appointments": {
          this.isStoresSelected = false;
          this.isBookingsSelected = true;
          this.isOrdersSelected = false;
          break;
        }
        default: {
          if (path.includes("/appointments")) {
            this.isStoresSelected = false;
            this.isBookingsSelected = true;
            this.isOrdersSelected = false;
          } else {
            this.isStoresSelected = false;
            this.isBookingsSelected = false;
            this.isOrdersSelected = false;
          }
          break;
        }
      }
    }
  }

  goToMyOrders() {
    if (
      localStorage.getItem("nVipaniwhiteshopkey") ||
      localStorage.getItem("retailerToken")
    ) {
      this.router.navigateByUrl("/myorders");
    } else {
      this.profileImageClicked();
    }
    this.resetConsumerTabFilters();
  }

  goToMyAddresses() {
    if (
      localStorage.getItem("nVipaniwhiteshopkey") ||
      localStorage.getItem("retailerToken")
    ) {
      this.router.navigateByUrl("/myaddresses");
    } else {
      this.profileImageClicked();
    }
  }

  goToPrivacyPolicy() {
    if (localStorage.getItem("nVipaniwhiteshopkey")) {
      this.router.navigateByUrl("/privacy-policy");
    } else {
      this.profileImageClicked();
    }
  }

  goToClickToCall() {
    if (
      localStorage.getItem("nVipaniwhiteshopkey") ||
      localStorage.getItem("retailerToken")
    ) {
      this.router.navigateByUrl("/clicktocall");
    } else {
      this.profileImageClicked();
    }
  }

  openImage() {
    this.imagesService.viewProductImages(
      [{ imageURL: this.user.profileImageURL }],
      null,
      null,
      null,
      "imageURL"
    );
  }
  onClickProfile(event) {
    if (window.innerWidth > 960) {
      // event.stopPropogation();
      event.preventDefault();
    } else {
      this.trigger.openMenu();
      // event.stopPropogation();
      event.preventDefault();
    }
  }
  onHover(event, type?) {
    setTimeout(() => {
      if (type) {
        // open
        if (window.innerWidth > 960) {
          this.trigger.openMenu();
          // event.stopPropogation();
          event.preventDefault();
        } else {
          // event.stopPropogation();
          event.preventDefault();
        }
      } else {
        // close
        if (window.innerWidth > 960) {
          this.trigger.closeMenu();
        } else {
          // event.stopPropogation();
          event.preventDefault();
        }
      }
    }, 1);
  }
  onClickLanguage() {
    this.language.openMenu();
  }
  goToMyProfile() {
    let addDialog;
    if (window.innerWidth < 450 || window.innerHeight < 550) {
      addDialog = {
        width: "100vw",
        minWidth: "100vw",
        height: "100Vh",
        minHeight: "100vh",
      };
    } else if (window.innerWidth < 1100) {
      addDialog = {
        width: "45vh",
        minWidth: "450px",
        height: "55vh",
        minHeight: "500px",
        maxHeight: "620px",
      };
    } else {
      addDialog = {
        width: "36vw",
        minWidth: "450px",
        height: "86vh",
        minHeight: "450px",
        maxHeight: "87vh",
      };
    }
    const myDialogRef = this.dialogService.openMatDialog(
      ProfileComponent,
      null,
      null,
      addDialog
    );
    myDialogRef.afterClosed().subscribe((data) => {
      if (data) {
        const user = JSON.parse(localStorage.getItem("user"));
        user.profileImageURL = data.profileImageURL;
        user.displayName = data.displayName;
        localStorage.setItem("user", JSON.stringify(user));
        this.localStorageService.islocalStorageUpdated.next(true);
      }
    });
  }
  goToDetailedOrders() {
    this.router.navigate(["myorders/detail-order"]);
  }
  isCustomerLogged() {
    const user = JSON.parse(localStorage.getItem("user"));
    return user && user.type && user.type === "B2C";
  }

  changePassword() {
    const matDialogRef = this.dialogService.openMatDialog(
      ChangePasswordComponent,
      null,
      true
    );
    matDialogRef.afterClosed().subscribe((data) => {
      console.log(data);
    });
  }

  getBusinessUnit() {
    return (
      this.user &&
      ((this.userGroup &&
        (this.userGroup.name === "Admin" ||
          this.userGroup.name === "Manager" ||
          this.userGroup.name === "Supervisor")) ||
        (this.user.companies &&
          this.user.companies.length &&
          this.user.companies[0].userGroupType &&
          (this.user.companies[0].userGroupType.name === "Admin" ||
            this.user.companies[0].userGroupType.name === "Manager" ||
            this.user.companies[0].userGroupType.name === "Supervisor")))
    );
  }
  resetConsumerTabFilters() {
    this.storesService.consumerMembers.selectedTags = [];
    this.storesService.consumerMembers.selectedAges = [];
    this.storesService.consumerMembers.selectedLocations = [];
    this.storesService.consumerMembers.selectedGenders = [];
    this.storesService.consumerSubscribers.selectedTags = [];
    this.storesService.consumerSubscribers.selectedAges = [];
    this.storesService.consumerSubscribers.selectedLocations = [];
    this.storesService.consumerSubscribers.selectedGenders = [];
    this.storesService.consumerMembers.appliedTagFilters = "";
    this.storesService.consumerMembers.appliedLocationFilters = "";
    this.storesService.consumerMembers.appliedAgeFilters = "";
    this.storesService.consumerMembers.appliedGenderFilters = "";
    this.storesService.consumerSubscribers.appliedTagFilters = "";
    this.storesService.consumerSubscribers.appliedLocationFilters = "";
    this.storesService.consumerSubscribers.appliedAgeFilters = "";
    this.storesService.consumerSubscribers.appliedGenderFilters = "";
  }

  isUserConsumer() {
    let index = -1;
    this.user = JSON.parse(localStorage.getItem("user"));
    if (this.user && this.user.companies && this.user.companies.length) {
      index = this.user.companies.findIndex((company) => company.consumer);
      if (index < 0 && this.user.type && this.user.type === "B2C") {
        index = 0;
      }
    }
    return index >= 0;
  }

  getCompanyLiveUrl() {
    if (!localStorage.getItem("widgetURL")) {
      let config = localStorage.getItem("config")
        ? JSON.parse(localStorage.getItem("config"))
        : JSON.parse(localStorage.getItem("companyConfig"));
      if (config && config.whiteshop && config.whiteshop.clickToCall) {
        this.companyLiveUrl = config.whiteshop.clickToCall.originUrl;
      }
    } else {
      this.companyLiveUrl = localStorage.getItem("widgetURL");
    }
    return this.companyLiveUrl;
  }

  goToWidget() {
    window.location.assign(this.getCompanyLiveUrl());
  }

  openNotifications() {
    const dialogConfig = {
      width: "30vw",
      minWidth: "30vw",
      height: "85vh",
      minHeight: "85vh",
      position: { top: "60px", right: "50px" },
      backdropClass: "sc-backdropBackground",
      panelClass: "sc-custom-container",
    };
    this.dialogService.openMatDialog(
      NotificationsComponent,
      null,
      null,
      dialogConfig
    );
  }
}
